/** Brief guidance during the transition into a newly created workspace. */
export function getOnboardingMessages(companyName) {
  const company = companyName ? companyName.trim() : '';
  return [
    company ? `Opening ${company}’s workspace…` : 'Opening your workspace…',
    'Review your documents in Knowledge Base.',
    'Ask questions about available content in Eva People.',
    'Check sources and share feedback on the answers.',
  ];
}
